import { LoaderCircleIcon } from 'lucide-react';

export function LoadingState({
  label = 'Loading…',
  fullPage = false,
}: {
  label?: string;
  fullPage?: boolean;
}) {
  return (
    <p
      role="status"
      className={`loading-state flex items-center justify-center gap-2 text-sm text-muted-foreground ${
        fullPage ? 'min-h-screen' : 'py-16'
      }`}
    >
      <LoaderCircleIcon className="size-4 motion-safe:animate-spin" aria-hidden="true" />
      {label}
    </p>
  );
}
